// utils/locationService.js
/**
 * safeGetPosition
 * ───────────────
 * • 3 tentatives max
 * • précision ≤ MIN_ACCURACY (par défaut 100 m)
 * • back-off linéaire (10 s → 20 s → 30 s)
 * • rejette PERMISSION_DENIED pour déclencher l’overlay
 */

const MIN_ACCURACY = 100; // mètres – modifiable

export async function safeGetPosition(
  { maxRetries = 3, initialTimeout = 10000 } = {}
) {
  let attempt = 0;
  let timeout = initialTimeout;

  while (attempt < maxRetries) {
    try {
      const pos = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          { enableHighAccuracy: true, timeout, maximumAge: 0 }
        )
      );

      if (pos.coords.accuracy <= MIN_ACCURACY) {
        return {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy
        };
      }
      // précision insuffisante → on réessaie
      throw new Error('LOW_ACCURACY');
    } catch (err) {
      if (err.code === 1 /* PERMISSION_DENIED */) {
        throw err;                    // on ne retente pas, on bloque l’appli
      }
      attempt += 1;
      timeout += 10000;               // back-off 10 s
    }
  }
  throw new Error('POSITION_UNAVAILABLE');
}
